import { render, staticRenderFns } from "./ShareEmbed.vue?vue&type=template&id=6855e52c&"
import script from "./ShareEmbed.vue?vue&type=script&lang=js&"
export * from "./ShareEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports